import { Dispatch, SetStateAction } from 'react';

/**
 * Wraps useState setState's function in shorthanded version used for setting object states.
 *
 * @example
 * const [state, setState] = useState({ value: 42, name: 'foo'});
 * const setObjectState = setWithObject(setState);
 *
 * setObjectState({value: 142});
 * // same as: setState(s => ({...s, value: 142}));
 *
 * @param seteState The react useState's setState function.
 */
export function setWithObject<TState>(setState: Dispatch<SetStateAction<TState>>) {
  return function (newState: Partial<TState>) {
    setState((s) => ({ ...s, ...newState }));
  };
}

/** Gets today's date, with hours set to 00:00:00 */
export function today() {
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  return date;
}
